import React from "react";
import { StickyBar } from "../components/StickyBar";
import { SalesPopups } from "../components/SalesPopups";
import { Footer } from "../components/Footer";
import { DessertMarquee } from "../components/ui/DessertMarquee";
import { Hero } from "../components/sections/Hero";
import { StorySection } from "../components/sections/StorySection";
import { PainSection } from "../components/sections/PainSection";
import { RevelationSection } from "../components/sections/RevelationSection";
import { ImagineSection } from "../components/sections/ImagineSection";
import { OfferStack } from "../components/sections/OfferStack";
import { SocialProofSection } from "../components/sections/SocialProofSection";
import { PricingSection } from "../components/sections/PricingSection";
import { FaqSection } from "../components/sections/FaqSection";
import { GuaranteeSection } from "../components/sections/GuaranteeSection";
import { CredibilitySection } from "../components/sections/CredibilitySection";
import { TwoPathsSection } from "../components/sections/TwoPathsSection";
import { FinalCta } from "../components/sections/FinalCta";
export function SalesPage() {
  return <div className="min-h-screen w-full bg-cream" data-id="element-626" data-mp="30twxhpp4fo21">
      <StickyBar data-id="element-627" data-mp="30uovf766xxvh" />
      <Hero data-id="element-628" data-mp="30u6n3c697t77" />
      <main data-id="element-629" data-mp="30rkhhi2xbnrm">
        <DessertMarquee data-id="element-630" data-mp="2vuu4j3mf18af" />
        <StorySection data-id="element-631" data-mp="2vvlnneyttdjt" />
        <PainSection data-id="element-632" data-mp="2vw538p107puo" />
        <RevelationSection data-id="element-633" data-mp="2vsr2tmbwhqpv" />
        <ImagineSection data-id="element-634" data-mp="3tica65ks5ua7" />
        <OfferStack data-id="element-635" data-mp="3tiubvhq7p0pi" />
        <SocialProofSection data-id="element-636" data-mp="3ti2hubc9jb1c" />
        <PricingSection data-id="element-637" data-mp="3tg88zve9n9dm" />
        <FaqSection data-id="element-638" data-mp="3ojrb49h9lgnc" />
        <GuaranteeSection data-id="element-639" data-mp="3okj4ddne32ag" />
        <CredibilitySection data-id="element-640" data-mp="3okar3knctuyq" />
        <TwoPathsSection data-id="element-641" data-mp="3jkenhmikk5jp" />
        <FinalCta data-id="element-642" data-mp="3jjn2f5mllq7o" />
      </main>
      <Footer data-id="element-643" data-mp="3jitqlq8s8aio" />
      <SalesPopups data-id="element-644" data-mp="3jmhmux5m3b13" />
    </div>;
}